@if (gridApi()) {
    <span [class]="cssClass()" [class.white-text]="useWhiteText()">
        @if (supportsSelect()) {
            <span>
                {{ prefix() }}{{ selectedRowCount | number }} of {{ totalRowCount | number }}
                row{{ totalRowCount === 1 ? '' : 's' }} selected{{ suffix() }}
            </span>
        } @else {
            <span>
                {{ prefix() }}{{ totalRowCount | number }} row{{ totalRowCount === 1 ? '' : 's' }}{{ suffix() }}
            </span>
        }
    </span>
}

